
export enum LabelPosition {
	LEFT = 'left',
	TOP = 'top',
	SELECT_PROMPT = 'selectPrompt'
}
